import { render } from "./vhpCard.vue?vue&type=template&id=25874ad5&scoped=true"
import script from "./vhpCard.vue?vue&type=script&lang=js"
export * from "./vhpCard.vue?vue&type=script&lang=js"

import "./vhpCard.scss?vue&type=style&index=0&id=25874ad5&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25874ad5"]])

export default __exports__